// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"5c12de7c","977":"fdbc7bf9"}[chunkId] + ".chunk.js";
};